module.exports = __webpack_public_path__ + "static/media/light_through_the_trees.76794928.jpg";